import React from 'react';


class DemoGraphicData extends React.Component {
    constructor(props) {
        super(props);
        this.state = { DemoGraphicInfo: {} };
    }

    componentDidMount() {
        this.getDemoGraphics(this.props.postalcode);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.postalcode !== nextProps.postalcode) {
            this.getDemoGraphics(nextProps.postalcode);
        }
    }

    getDemoGraphics(postalcode) {
        var self = this;
        var url = window.sessionStorage.getItem("BaseAPI") + "demographics/" + postalcode;

        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + window.sessionStorage.getItem("APIKey")
            },
            method: "GET"
        })
            .then(response => response.json())
            .then(json => {
                var arry = [];
                if (json && json.alldemo && json.alldemo.length > 0) {
                    arry = json.alldemo[0];
                }
                self.setState({ DemoGraphicInfo: arry });
            })
            .catch(function (data) {
                console.log(data)
            });
    }

    getRenderDetails() {
        var detailInfo = this.state.DemoGraphicInfo;
        var zipCode = (detailInfo.zipCode !== undefined) ? detailInfo.zipCode : this.props.postalcode;
        var zipTitle = 'Zip (' + zipCode + ')';

        return (
            <div>
                <DemoGraphicSection detailInfo={detailInfo} zipCodeTitle={zipTitle} />
                <IncomeAndJobSection detailInfo={detailInfo} zipCodeTitle={zipTitle} />
                <EducationSection detailInfo={detailInfo} zipCodeTitle={zipTitle} />
                <ClimateSection detailInfo={detailInfo} zipCodeTitle={zipTitle} />
                <ResidentialSection detailInfo={detailInfo} zipCodeTitle={zipTitle} />
            </div>
        );
    }

    render(props) {

        var renderDetail = this.getRenderDetails();

        return (
            <div>
                {renderDetail}
            </div>
        );
    }
}

class SectionDetail extends React.Component {
    render(props) {
        return (
            <tr>
                <td data-title="&nbsp;">{this.props.name}</td>
                <td data-title="Zip">{this.props.zip}</td>
                <td data-title="County">{this.props.county}</td>
                <td data-title="National">{this.props.national}</td>
            </tr>
        );
    }
}

class ClimateSectionDetail extends React.Component {
    render(props) {
        return (
            <tr>
                <td data-title="&nbsp;" dangerouslySetInnerHTML={{ __html: this.props.name }}></td>
                <td data-title="Zip" dangerouslySetInnerHTML={{ __html: this.props.zip }}></td>
                <td data-title="County" dangerouslySetInnerHTML={{ __html: this.props.county }}></td>
                <td data-title="National" dangerouslySetInnerHTML={{ __html: this.props.national }}></td>
            </tr>
        );
    }
}

class SectionDetailTitle extends React.Component {
    render(props) {
        return (
            <tr>
                <th>{this.props.name}</th>
                <th>{this.props.zip}</th>
                <th>{this.props.county}</th>
                <th>{this.props.national}</th>
            </tr>
        );
    }
}

class DemoGraphicSection extends React.Component {
    render(props) {
        var detail = this.props.detailInfo;
        var title = this.props.zipCodeTitle;

        return (
            <div>
                <div  className="sub_header_style" style={HeaderStyle}>
                    <div>Demographics <div className="demographic-disc">Data is provided by the United States Census Bureau and is updated every decade</div></div>
                </div>
                <table className="area_data" cellPadding="0" cellSpacing="0">
                    <thead>
                    <SectionDetailTitle
                        name=''
                        zip={title}
                        county='County'
                        national='National' />
                    </thead>
                    <tbody>
                    <SectionDetail
                        name='Population'
                        zip={detail.PopulationZip}
                        county={detail.PopulationCounty}
                        national={detail.PopulationNational} />
                    <SectionDetail
                        name='Population change since 1990'
                        zip={detail.PopulationChangeSince1990Zip}
                        county={detail.PopulationChangeSince1990County}
                        national={detail.PopulationChangeSince1990National} />
                    <SectionDetail
                        name='Population density'
                        zip={detail.PopulationDensityZip}
                        county={detail.PopulationDensityCounty}
                        national={detail.PopulationDensityNational} />
                    <SectionDetail
                        name='Male'
                        zip={detail.MaleZip}
                        county={detail.MaleCounty}
                        national={detail.MaleNational} />
                    <SectionDetail
                        name='Female'
                        zip={detail.FemaleZip}
                        county={detail.FemaleCounty}
                        national={detail.FemaleNational} />
                    <SectionDetail
                        name='Never married'
                        zip={detail.NeverMarriedZip}
                        county={detail.NeverMarriedCounty}
                        national={detail.NeverMarriedNational} />
                    <SectionDetail
                        name='Married'
                        zip={detail.MarriedZip}
                        county={detail.MarriedCounty}
                        national={detail.MarriedNational} />
                    <SectionDetail
                        name='Separated'
                        zip={detail.SeparatedZip}
                        county={detail.SeparatedCounty}
                        national={detail.SeparatedNational} />
                    <SectionDetail
                        name='Widowed'
                        zip={detail.WidowedZip}
                        county={detail.WidowedCounty}
                        national={detail.WidowedNational} />
                    <SectionDetail
                        name='Divorced'
                        zip={detail.DivorcedZip}
                        county={detail.DivorcedCounty}
                        national={detail.DivorcedNational} />
                    <SectionDetail
                        name='Number of households'
                        zip={detail.NumberOfHouseHoldZip}
                        county={detail.NumberOfHouseHoldCounty}
                        national={detail.NumberOfHouseHoldNational} />
                    <SectionDetail
                        name='Average household size'
                        zip={detail.AverageHouseHoldSizeZip}
                        county={detail.AverageHouseHoldSizeCounty}
                        national={detail.AverageHouseHoldSizeNational} />
                    <SectionDetail
                        name='Median age'
                        zip={detail.MedialAgeZip}
                        county={detail.MedialAgeCounty}
                        national={detail.MedialAgeNational} />
                    </tbody>
                </table>
            </div>)
    }
}

class IncomeAndJobSection extends React.Component {
    render(props) {
        var detail = this.props.detailInfo;
        var title = this.props.zipCodeTitle;

        return (
            <div>
                <div className="sub_header_style" style={HeaderStyle}>
                    <div>Incomes &amp; Jobs <div className="demographic-disc">Data is provided by the United States Census Bureau and is updated every decade</div></div>
                </div>
                <table className="area_data" cellPadding="0" cellSpacing="0">
                    <thead>
                    <SectionDetailTitle
                        name=''
                        zip={title}
                        county='County'
                        national='National' />
                    </thead>
                    <tbody>
                    <SectionDetail
                        name='Median household income'
                        zip={detail.MedianHouseHoldIncomeZip}
                        county={detail.MedianHouseHoldIncomeCounty}
                        national={detail.MedianHouseHoldIncomeNational} />
                    <SectionDetail
                        name='Average household income'
                        zip={detail.AverageHouseHoldIncomeZip}
                        county={detail.AverageHouseHoldIncomeCounty}
                        national={detail.AverageHouseHoldIncomeNational} />
                    <SectionDetail
                        name='Per capita income'
                        zip={detail.PCIZip}
                        county={detail.PCICounty}
                        national={detail.PCINational} />
                    <SectionDetail
                        name='Median disposable income'
                        zip={detail.MDIZip}
                        county={detail.MDICounty}
                        national={detail.MDINational} />
                    <SectionDetail
                        name='Average total household expenditure'
                        zip={detail.ATHEZip}
                        county={detail.ATHECounty}
                        national={detail.ATHENational} />
                    <SectionDetail
                        name='Sales tax rate'
                        zip={detail.STRZip}
                        county={detail.STRCounty}
                        national={detail.STRNational} />
                    <SectionDetail
                        name='White collar jobs'
                        zip={detail.WCJZip}
                        county={detail.WCJCounty}
                        national={detail.WCJNational} />
                    <SectionDetail
                        name='Blue collar jobs'
                        zip={detail.BCJZip}
                        county={detail.BCJCounty}
                        national={detail.BCJNational} />
                    </tbody>
                </table></div>)
    }
}

class EducationSection extends React.Component {
    render(props) {
        var detail = this.props.detailInfo;
        var title = this.props.zipCodeTitle;

        return (
            <div>
                <div className="sub_header_style" style={HeaderStyle}>
                    <div>Education <div className="demographic-disc">Data is provided by the United States Census Bureau and is updated every decade</div></div>
                </div>
                <table className="area_data" cellPadding="0" cellSpacing="0">
                    <thead>
                    <SectionDetailTitle
                        name=''
                        zip={title}
                        county='County'
                        national='National' />
                    </thead>
                    <tbody>
                    <SectionDetail
                        name='Less than 9th grade'
                        zip={detail.LT9GZip}
                        county={detail.LT9GCounty}
                        national={detail.LT9GNational} />
                    <SectionDetail
                        name='Some high school'
                        zip={detail.SHSZip}
                        county={detail.SHSCounty}
                        national={detail.SHSNational} />
                    <SectionDetail
                        name='High school graduate'
                        zip={detail.HSGZip}
                        county={detail.HSGCounty}
                        national={detail.HSGNational} />
                    <SectionDetail
                        name='Some college'
                        zip={detail.SCZip}
                        county={detail.SCCounty}
                        national={detail.SCNational} />
                    <SectionDetail
                        name='Associate degree'
                        zip={detail.ADZip}
                        county={detail.ADCounty}
                        national={detail.ADNational} />
                    <SectionDetail
                        name='Bachelors degree'
                        zip={detail.BDZip}
                        county={detail.BDCounty}
                        national={detail.BDNational} />
                    <SectionDetail
                        name='Graduate degree'
                        zip={detail.GDZip}
                        county={detail.GDCounty}
                        national={detail.GDNational} />
                    </tbody>
                </table></div>)
    }
}

class ClimateSection extends React.Component {
    render(props) {
        var detail = this.props.detailInfo;
        var title = this.props.zipCodeTitle;

        return (
            <div>
                <div className="sub_header_style" style={HeaderStyle}>
                    <div>Climate <div className="demographic-disc">Data is provided by the United States Census Bureau and is updated every decade</div></div>
                </div>
                <table className="area_data" cellPadding="0" cellSpacing="0">
                    <thead>
                    <SectionDetailTitle
                        name=''
                        zip={title}
                        county='County'
                        national='National' />
                    </thead>
                    <tbody>
                    <ClimateSectionDetail
                        name='Average January high'
                        zip={detail.AJHTZip}
                        county={detail.AJHTCounty}
                        national={detail.AJHTNational} />
                    <ClimateSectionDetail
                        name='Average January low'
                        zip={detail.AJLTZip}
                        county={detail.AJLTCounty}
                        national={detail.AJLTNational} />
                    <ClimateSectionDetail
                        name='Average July high'
                        zip={detail.AJUHTZip}
                        county={detail.AJUHTCounty}
                        national={detail.AJUHTNational} />
                    <ClimateSectionDetail
                        name='Average July low'
                        zip={detail.AJULTZip}
                        county={detail.AJULTCounty}
                        national={detail.AJULTNational} />
                    <ClimateSectionDetail
                        name='Annual precipitation'
                        zip={detail.APZip}
                        county={detail.APCounty}
                        national={detail.APNational} />
                    <ClimateSectionDetail
                        name='Earthquake risk'
                        zip={detail.ERZip}
                        county={detail.ERCounty}
                        national={detail.ERNational} />
                    <ClimateSectionDetail
                        name='Weather risk'
                        zip={detail.WRZip}
                        county={detail.WRCounty}
                        national={detail.WRNational} />
                    <ClimateSectionDetail
                        name='Air pollution index'
                        zip={detail.APOIZip}
                        county={detail.APOICounty}
                        national={detail.APOINational} />
                    </tbody>
                </table></div>);
    }
}

class ResidentialSection extends React.Component {
    render(props) {
        var detail = this.props.detailInfo;
        var title = this.props.zipCodeTitle;

        return (
            <div>
                <div className="sub_header_style" style={HeaderStyle}>
                    <div>Residential <div className="demographic-disc">Data is provided by the United States Census Bureau and is updated every decade</div></div>
                </div>
                <table className="area_data" cellPadding="0" cellSpacing="0">
                    <thead>
                    <SectionDetailTitle
                        name=''
                        zip={title}
                        county='County'
                        national='National' />
                    </thead>
                    <tbody>
                    <SectionDetail
                        name='Average home sale price'
                        zip={detail.AHSPZip}
                        county={detail.AHSPCounty}
                        national={detail.AHSPNational} />
                    <SectionDetail
                        name='Homes owned'
                        zip={detail.HOZip}
                        county={detail.HOCounty}
                        national={detail.HONational} />
                    <SectionDetail
                        name='Homes rented'
                        zip={detail.HRZip}
                        county={detail.HRCounty}
                        national={detail.HRNational} />
                    <SectionDetail
                        name='Vacant homes'
                        zip={detail.VHZip}
                        county={detail.VHCounty}
                        national={detail.VHNational} />
                    <SectionDetail
                        name='Median dwelling age (years)'
                        zip={detail.MDAZip}
                        county={detail.MDACounty}
                        national={detail.MDANational} />
                    <SectionDetail
                        name='Median years in residence'
                        zip={detail.MYIRZip}
                        county={detail.MYIRCounty}
                        national={detail.MYIRNational} />
                    <SectionDetail
                        name='Annual residential turnover'
                        zip={detail.ARTZip}
                        county={detail.ARTCounty}
                        national={detail.ARTNational} />
                    <SectionDetail
                        name='Median travel time to work'
                        zip={detail.MTTTWZip}
                        county={detail.MTTTWCounty}
                        national={detail.MTTTWNational} />
                    <SectionDetail
                        name='Transportation to work: Public'
                        zip={detail.TTWPZip}
                        county={detail.TTWPCounty}
                        national={detail.TTWPNational} />
                    <SectionDetail
                        name='Transportation to work: Drive / Carpool'
                        zip={detail.TTWDCZip}
                        county={detail.TTWDCCounty}
                        national={detail.TTWDCNational} />
                    <SectionDetail
                        name='Transportation to work: Walk / Bike / Other'
                        zip={detail.TTWWBOZip}
                        county={detail.TTWWBOCounty}
                        national={detail.TTWWBONational} />
                    <SectionDetail
                        name='Transportation to work: Work at home'
                        zip={detail.TTWWAHZip}
                        county={detail.TTWWAHCounty}
                        national={detail.TTWWAHNational} />
                    </tbody>
                </table></div>)
    }
}

const HeaderStyle = {

}

/*const DetailStyle = {
    padding: "10px"
}*/

export default DemoGraphicData;